// extracted by mini-css-extract-plugin
export default {"card":"MerchantCard_card__8Zbla","card_logo":"MerchantCard_card_logo__8vSVi","card_name":"MerchantCard_card_name__FYq3H"};